<div class="form__group field">
  <div class="rt-card-img">
    <img [ngStyle]="{'object-fit': viewType}" class="upload-doc-img" [src]="imagePreview ? imagePreview : '/assets/image/img-thumb.png'" alt="image" />
  </div>
</div>